import axios from 'axios';

// API configuration
const getBaseApiUrl = () => {
  // Если есть переменная окружения - используем её
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  
  // Если запущено в браузере и есть window.location - используем относительный URL
  // (nginx проксирует /api/ на backend)
  if (typeof window !== 'undefined' && window.location) {
    return window.location.origin;
  }
  
  // Для разработки используем localhost
  return 'http://localhost:5001';
};

export const getApiUrl = (endpoint) => {
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  const baseUrl = getBaseApiUrl();
  return `${baseUrl}${cleanEndpoint}`;
};

// Axios instance for API requests
export const apiClient = axios.create({
  baseURL: getBaseApiUrl(),
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add telegram ID header dynamically
apiClient.interceptors.request.use((config) => {
  // Telegram ID will be added by the hook that uses this instance
  return config;
});

export default getBaseApiUrl();

